var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"fit-content"}},[_c('canvas',{attrs:{"id":"video-canvas1"},on:{"click":function($event){return _vm.detailShowCCTV()}}})])}
var staticRenderFns = []

export { render, staticRenderFns }